import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '../../Buttons/TextButton';
import ArrowLeft from '../../Icons/ArrowLeft';
import { BiEventType } from '../../biLogger/constants';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import s from './BackToStreamButton.scss';
var BackToStreamButton = function (_a) {
    var className = _a.className, exitDuperbrowse = _a.exitDuperbrowse, parent = _a.parent, currentItem = _a.currentItem;
    var t = useTranslation().t;
    if (!parent || !currentItem) {
        return null;
    }
    return (React.createElement(TextButton, { icon: ArrowLeft, variant: "unbranded", size: "small", biData: __assign(__assign({ evid: BiEventType.BACK_TO_CLICK }, getBasicBiDataForDuperItem(currentItem)), { link_url: parent.url, next_itemid: parent.itemId, next_typeid: parent.typeId }), className: classnames(s['duperexit'], className), onClick: exitDuperbrowse }, parent.title || t('deviation.duperbrowse.back')));
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
//# sourceMappingURL=BackToStreamButton.js.map